import Vue from 'vue';
import {$isPC, getCarSeries} from "../../static/js/http";
import Device from "browser-device-js";
var medias = [];
const main = {
  data() {
    return {
      exteriorColorId: 0,
      version: 'low',
      insideColorId: 0,
      exteriorConfig: window.getConfigure('exterior'),
      exteriorConfigItems:window.getConfigure('exterior').items,
      insideConfig: window.getConfigure('inside'),
      versionConfig: window.getConfigure('carVersion'),
      policyConfig: window.getConfigure('policy'),
      carSeries: require('@/data/CarSeries.json'),
      toolId: -1,
      message: null,
      kfUrl: 'https://sh-p2.ntalker.com/downt/t2d/chat.php?v=2019.04.29&siteid=kf_9255&settingid=kf_9255_1488248911979&baseuri=https%3A%2F%2Fdl.ntalker.com%2Fjs%2Fxn6%2F&mobile=1ref=https%3A%2F%2Fwww.dongfeng-nissan.com.cn%2Fcar%2Fqashqai&tit=%E5%85%A8%E6%96%B0%E9%80%8D%E5%AE%A2%7C%E4%B8%9C%E9%A3%8E%E6%97%A5%E4%BA%A7%E5%AE%98%E6%96%B9%E7%BD%91%E7%AB%99&iframechat=0&header=0&orderid=%5B%5D&rnd=1567562695237',
      openedKf: false,
      curentInside: null,
      versionId: 0,
      opendVersionList: false,
      opendInsideList: false,
      opendExteriorList: false,
      isLoaded: false,
      configUrl: '',
      currentVersion: null,
      curInsieColorData: null,
      curExteriorData: null,
      showMessage: false,
      isMobile: false,
      selectButton: null,
      config: {
        car: '第七代天籁',
        carName: '',
        outColor: '天际红',
        innerColor: '米色',
        carType: 1,
        options: [],
      },
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
      mobileTid: 0,
      media: { videoList: [], version: '', title: '' },
      hideVersionId:0,
      isSelectEteriorColor:false,
      startTime:0,
      carseries_id:getConfigure("carVersion").cbbCarSeriesId,
      device:new Device(),
    };
  },
  methods: {
    setEteriorColor(item, sendAction = true,id=0) {
      var info = {
        dynamic: {
          carseries_id:this.carseries_id,
          id:id,
          target:item.name.replace("<br>","")
        }
      }
      if (sendAction) track("dn_web-20210421172811-cf06-{carseries_id}-{id}",info);
      this.curExteriorData = item;
      this.$store.commit('setData', { key: 'config.outColor', val: this.curExteriorData.name });
      this.$refs.car.setExteriorColor(item.code);
    },
    setInsideColor(item, sendAction = true,index=0) {
      var info = {
        dynamic: {
          carseries_id: this.carseries_id,
          id:index,
          target:item.name.replace("<br>","")
        }
      }
      if (sendAction) track("dn_web-20210421172811-cf07-{carseries_id}-{id}",info);
      this.curInsieColorData = item;
      this.$store.commit('setData', { key: 'config.innerColor', val: this.curInsieColorData.name });
      this.$refs.car.setInsideColor(item.code, this.currentVersion.code);
    },
    setVersion(item) {
      this.showMessage = true;
      if (this.isMobile) {
        this.showMessageContent = true;
        this.toolId = -1;
        clearTimeout(this.mobileTid);
        this.$refs.message.showContent(true);
        this.mobileTid = setTimeout(() => {
          this.showMessageContent = false;
          this.$refs.message.showContent(false);
        }, 3000);
      }
      this.currentVersion = item;
      clearTimeout(this.hideVersionId);
      this.$store.commit('setData', { key: 'config.carType', val: this.currentVersion.id });
      this.$store.commit('setData', { key: 'config.carName', val: this.currentVersion.name });
      this.setMessage(item);
      this.updateInsidItems();
      this.$nextTick(() => {
        if(this.currentVersion.tip){
          this.hideVersionId = setTimeout(this.hideVersionTip,4000);
        }
        if (this.$refs.insideColorList) {
          let selectId = 0;
          for (let i = 0; i < this.curentInside.items.length; i++) {
            if (this.curentInside.items[i].name == this.curInsieColorData.name) {
              selectId = i;
            }
          }
          this.$refs.insideColorList.selectId = selectId;
          console.log(this.curInsieColorData.name);
          console.log(`${selectId}:${this.$refs.insideColorList.getSelectData()}`);
          WebglMessageEvent.SHOW_INTERIOR.data.id = this.$refs.insideColorList.getSelectData().code;
          this.curInsieColorData = this.$refs.insideColorList.getSelectData();
          this.$refs.car.setVersion(item.code, this.$refs.car.isExterior == true ? 0 : 1);
        } else {
          this.$refs.car.setVersion(item.code, this.$refs.car.isExterior == true ? 0 : 1);
        }
        var info = {
          dynamic: {
            carseries_id: this.carseries_id,
            cartype_id:this.currentVersion.cbbCarTypeId
          }
        }
        if(this.currentVersion.name.indexOf("暗夜")){
          info = {
            dynamic: {
              carseries_id: this.carseries_id,
              id:this.currentVersion.cbbCarTypeId,
              target:this.currentVersion.name
            }
          }
          track("dn_web-20210824175948-q3pg-{carseries_id}-{id}",info);
        }
        else{
          track("dn_web-20210421172811-cf05-{carseries_id}-{cartype_id}",info);
        }
        if(getConfigure('exterior').isHideVersion.toString().indexOf(item.id)!=-1){
          var items = [];
          for(var i=0;i<getConfigure('exterior').items.length;i++){
            if(!getConfigure('exterior').items[i].hideVersionId||getConfigure('exterior').items[i].hideVersionId.toString().indexOf(item.id.toString())==-1){
              items.push(getConfigure('exterior').items[i]);
            }
          }
          this.exteriorConfigItems = items;
          setTimeout(()=>{
            var id = this.exteriorConfig.hideSelectId!=undefined?this.exteriorConfig.hideSelectId:this.exteriorConfigItems.length-1;
            if(this.isSelectEteriorColor){
              for(var j=0;j<this.exteriorConfigItems.length;j++){
                if(this.exteriorConfigItems[j]==this.curExteriorData){
                  id = j;
                }
              }
            }
            if(this.$refs.car.isExterior)
              this.$refs.outSideColorList.onSelect(this.exteriorConfigItems[id],id);
            this.curExteriorData = this.exteriorConfigItems[id];
          },50)
        }
        else if(getConfigure('exterior').isHideVersion!=undefined){
          var b = this.exteriorConfigItems!=getConfigure('exterior').items;
          this.exteriorConfigItems = getConfigure('exterior').items;
          this.$nextTick(()=>{
            if(b){
              var id = this.exteriorConfig.selectId==undefined?0:this.exteriorConfig.selectId;
              if(this.isSelectEteriorColor){
                for(var j=0;j<this.exteriorConfigItems.length;j++){
                  if(this.exteriorConfigItems[j]==this.curExteriorData){
                    id = j;
                  }
                }
              }
              if(this.$refs.car.isExterior)
                this.$refs.outSideColorList.onSelect(this.exteriorConfigItems[id],id);
              this.curExteriorData = this.exteriorConfigItems[id];
            }
          })
        }
        // this.updateConfigUrl();
      });
    },
    hideVersionTip(){
      clearTimeout(this.hideVersionId);
      this.hideVersionId = 0;
      $(this.$refs['versionTip']).css('display','none');
    },
    isBaiDu(){
      const ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf('baiduboxapp/') > -1) {
        return true;
      }
      return false;
    },
    setMessage(item) {
      if (!this.message) {
        this.message = { title: '', version: '', price: '', content: '', details: [] };
      }
      this.message.title = this.versionConfig.title;
      this.message.version = GLOBAL_VARS.terminal==='chebaba'? item.cbbname: item.name;
      this.message.content = item.content;
      this.message.price = item.price;
      this.message.price1 = item.price1;
      this.message.showPrice = item.showPrice;
      this.message.details = item.details;
      this.versionId = item.id;
      this.$nextTick(()=>{
        if(!this.isMobile){
          this.updateMessageBg();
        }
      })
    },
    updateMessageBg(){
      if(this.$refs['message']){
        var rect = this.$refs['message'].$el.getBoundingClientRect();
        var w = rect.width+80;
        this.mbgWidth = (w+30)+'px';
        this.arrowLeft = (w-30)+'px';
        this.mpwidth = -(w-30)+'px';
      }
    },
    onSelectButton(id, bt,action=true) {
      var info;
      info = {
        dynamic: {
          carseries_id: this.carseries_id,
        }
      }
      if (this.toolId == id) {
        this.toolId = -1;
      }
      else if(id==2){
        if(this.isBaiDu()){
          window.open(window.location.origin+"/buy/test-drive?car_series_id="+this.versionConfig.cbbCarSeriesId, "self");
        }
        else{
          window.open(window.location.origin+"/buy/test-drive?car_series_id="+this.versionConfig.cbbCarSeriesId, "blank");
        }
        track("dn_web-20210421172811-ur03-{carseries_id}",info);
        // this.toolId = -1;
        bt.selected = false;
      }
      else if(id==1){
        this.selectButton = bt;
        this.toolId = 1;
      }
      else {
        this.toolId = id;
      }
      if (this.toolId == 1) {
        this.showMessage = false;
        window.AICCFunc.showChatDialog({showOrHide:'hide'});
        action&&track("dn_web-20210421172811-ur01-{carseries_id}",info);
      } else if (this.toolId == 2) {
        window.AICCFunc.showChatDialog({showOrHide:'hide'});
      } else if (this.toolId == 3) {
        this.toolId = -1;
        window.AICCFunc.showChatDialog({showOrHide:'show'});
        $('.aicc_cth_btn').click(()=>{
          if(this.closeTopContent){
            this.closeTopContent();
          }
        })
        action&&track("dn_web-20210421172811-ur04-{carseries_id}",info);
      }
    },
    onSuccess() {
      let time = (new Date().getTime()-this.startTime)/1000;
      console.log('加载时长：'+time);
      var info = {
        dynamic: {
          carseries_id: this.carseries_id,
          id:0,
          target:time+'s'
        }
      }
      track("dn_web-20210421172811-lm01-{carseries_id}-{id}",info);
      this.device.getDevice();
      info = {
        dynamic: {
          carseries_id: this.carseries_id,
          id:0,
          target:this.device.getBrowser()
        }
      }
      track("dn_web-20210825192615-l1y1-{carseries_id}-{id}",info);
      this.updateConfigUrl();
      this.$refs.car.showMarker(true);
      if (this.isMobile) {
        switch (UrlValue('car')) {
          case 'altima':
            WebglMessageEvent.SHOW_EXTERIOR.data.fov = 60;
            break;
          case 'lannia':
            WebglMessageEvent.SHOW_EXTERIOR.data.fov = 60;
            break;
          case 'tiida':
            WebglMessageEvent.SHOW_EXTERIOR.data.fov = 55;
            break;
          case 'sylphy-classic':
            WebglMessageEvent.SHOW_EXTERIOR.data.fov = 70;
            break;
          case 'xtrail':
            WebglMessageEvent.SHOW_EXTERIOR.data.fov = 65;
            break;
          case 'terra':
            WebglMessageEvent.SHOW_EXTERIOR.data.fov = 60;
            break;
          case 'qashqai':
            WebglMessageEvent.SHOW_EXTERIOR.data.fov = 67;
            break;
          case 'kicks':
            WebglMessageEvent.SHOW_EXTERIOR.data.fov = 64;
            break;
          default:
            WebglMessageEvent.SHOW_EXTERIOR.data.fov = 70;
            break;
        }
      } else {
        switch (UrlValue('car')) {
          case 'altima':
            WebglMessageEvent.SHOW_EXTERIOR.data.fov = 35;
            break;
          case 'lannia':
            WebglMessageEvent.SHOW_EXTERIOR.data.fov = 35;
            break;
          case 'tiida':
            WebglMessageEvent.SHOW_EXTERIOR.data.fov = 35;
            break;
          case 'terra':
            WebglMessageEvent.SHOW_EXTERIOR.data.fov = 35;
            break;
          case 'xtrail':
            WebglMessageEvent.SHOW_EXTERIOR.data.fov = 35;
            break;
          case 'murano':
            WebglMessageEvent.SHOW_EXTERIOR.data.fov = 35;
            break;
          case 'kicks':
            WebglMessageEvent.SHOW_EXTERIOR.data.fov = 35;
            break;
          default:
            WebglMessageEvent.SHOW_EXTERIOR.data.fov = 40;
            break;
        }
      }
      if(this.exteriorConfig.sceneId!=undefined){
        WebglMessageEvent.SHOW_EXTERIOR.data.sceneId = this.exteriorConfig.sceneId;
      }
      this.$refs.car.postMessage(WebglMessageEvent.SHOW_EXTERIOR);
      setTimeout(() => {
        this.isLoaded = true;
        if (this.$refs.policyView) this.$refs.policyView.$refs.mySwiper.swiper.autoplay.start();
        if (this.$refs.car) {
          $(this.$refs.car.$el).animate({ opacity: 1 }, 1000);
        }
      }, 200);
      if (this.isMobile) {
        clearTimeout(this.mobileTid);
        this.mobileTid = setTimeout(() => {
          this.showMessageContent = false;
          this.$refs.message.showContent(false);
        }, 3000);
      }
    },
    updateInsidItems() {
      const version = this.versionId;
      this.insideConfig.items.filter(item => {
        if (item.carType == version) {
          this.curentInside = item;
        }
      });
      if (!this.curInsieColorData) {
        this.curInsieColorData = this.curentInside.items[0];
      }
    },
    onProgess(progess) {
      if (this.$refs.loading) this.$refs.loading.setPercent(Math.round(progess));
      if (this.$refs.loading_bac) {
        $(this.$refs.loading_bac).css('opacity', progess / 100);
      }
      if (this.$refs.appToolContainer) {
        $(this.$refs.appToolContainer).css('opacity', progess / 100);
      }
    },
    showStaff() {
      this.isOpenSize = !this.isOpenSize;
      if(this.$refs.sizeButton){
        this.sizeIcon = !this.isOpenSize?path+'static/images/pc/icon/size_open.svg':path+'static/images/pc/icon/size_off.svg'
      }
      const b = !WebglMessageEvent.SHOW_EXTERIOR.data.staff;
      WebglMessageEvent.SHOW_EXTERIOR.data.staff = b;
      this.$refs.car.postMessage(WebglMessageEvent.SHOW_EXTERIOR);
      if (this.$refs.car.isExterior) {
        var info = {
          dynamic: {
            carseries_id: this.carseries_id,
          }
        }
        if (this.isOpenSize) {
          track("dn_web-20210421172811-cf01-{carseries_id}",info);
        } else {
          track("dn_web-20210421172811-cf02-{carseries_id}",info);
        }
      }
    },
    updateConfigUrl() {
      const { cid } = this.versionConfig;
      let car = this.carSeries.data.filter(item => {
        if (cid == item.CID) {
          return item;
        }
      });
      if (car.length > 0) {
        car = car[0];
      } else {
        return;
      }
      const id = car.CID;
      const carTypeId = this.currentVersion.CarTypeId;
      if(GLOBAL_VARS.online3DPath!="./"){
        this.configUrl = `/car-configuration-preferences-page?car_series_id=${id}`;
      }
      else{
        this.configUrl = `https://feat-nissan201126-dndcfenge-node-site.nissan-website.dev.dndc.cloud//car-configuration-preferences-page?car_series_id=${id}`;
      }
    },
    showMedia(name) {
      var item ={};
      var reg = new RegExp( ' ' , "g" );
      if(medias.indexOf(name)==-1){
        medias.push(name);
      }
      var id = medias.indexOf(name);
      var info = {
        dynamic: {
          carseries_id: this.carseries_id,
          id:id,
          target:name
        }
      }
      this.currentVersion.details.filter(it=>{
        if(it.name==name||it.name.replace(reg,'').indexOf(name.replace(reg,''))!=-1){
          item = it;
        }
      })
      if (this.$refs.car.isExterior) {
        track("dn_web-20210421172811-td01-{carseries_id}-{id}",info);
      }
      else{
        track("dn_web-20210421172811-td02-{carseries_id}-{id}",info);
      }
      item = JSON.parse(JSON.stringify(item));
      this.media = { videoList: [], version: '', title: '' };
      this.media.videoList = item.urls;
      this.media.title = item.name;
      this.media.version = this.currentVersion.name;
      this.$nextTick(() => {
        if (this.$refs.mediaPanel) {
          !$isPC()&&this.$refs.mediaPanel.playVideo(null, 1);
        }
      });
    },
    clickMenu(name) {
      var item = {};
      var reg = new RegExp(' ', "g")
      var item ={};
      var reg = new RegExp( ' ' , "g" );
      if(medias.indexOf(name)==-1){
        medias.push(name);
      }
      var id = medias.indexOf(name);
      var info = {
        dynamic: {
          carseries_id: this.carseries_id,
          id:id,
          target:name
        }
      }
      this.currentVersion.details.filter(it => {
        if (it.name == name || it.name.replace(reg, '').indexOf(name.replace(reg, '')) != -1) {
          item = it;
        }
      })
      if(this.$refs.car.isExterior){
        track("dn_web-20210421172811-td03-{carseries_id}-{id}",info);
      }
      else{
        track("dn_web-20210421172811-td02-{carseries_id}-{id}",info);
      }
    },
    gotoHome(evt) {
      if(window.AICCFunc){
        window.AICCFunc.showChatDialog({showOrHide:'hide'});
      }
      var info = {
        dynamic: {
          carseries_id: this.carseries_id,
        }
      }
      track("dn_web-20210421172811-ul01-{carseries_id}",info);
      event.preventDefault();
      this.$router.push({ path: '/' });
      document.title = '东风日产线上展厅';
    },
    setStatus(isOutside){
      let query = this.$router.history.current.query;
      let path = this.$router.history.current.path;
      let newQuery = JSON.parse(JSON.stringify(query));
      if(isOutside){
        if(newQuery.status!="outside"){
          newQuery.status = "outside";
          this.$router.replace({path,query:newQuery});
        }
      }
      else{
        if(newQuery.status!="inside"){
          newQuery.status = "inside";
          this.$router.replace({path,query:newQuery});
        }
      }
    }
  },
  mounted() {
    this.startTime = new Date().getTime();
    WebglMessageEvent.SHOW_EXTERIOR.data.staff = false;
    this.exteriorConfig = window.getConfigure('exterior');
    this.insideConfig = window.getConfigure('inside');
    this.versionConfig = window.getConfigure('carVersion');
    this.policyConfig = window.getConfigure('policy');
    WebglMessageEvent.SHOW_EXTERIOR.data.colorId = this.exteriorConfig.items[0].code;
    WebglMessageEvent.SHOW_EXTERIOR.data.version = this.versionConfig.items[0].code;
    this.currentVersion = this.versionConfig.items[0];
    this.versionId = this.versionConfig.items[0].id;
    this.curExteriorData = this.exteriorConfig.items[0];
    this.setMessage(this.versionConfig.items[0]);
    this.updateInsidItems();
    document.title = this.versionConfig.dtitle?`${this.versionConfig.dtitle}|线上展厅`:`${this.versionConfig.title}|线上展厅`;
    this.$store.commit('setData', { key: 'config.car', val: this.versionConfig.title });
    this.$store.commit('setData', { key: 'config.carName', val: this.versionConfig.items[0].name });
    this.$store.commit('setData', { key: 'config.outColor', val: this.exteriorConfig.items[0].name });
    this.$store.commit('setData', { key: 'config.innerColor', val: this.insideConfig.items[0].items[0].name });
    this.$store.commit('setData', { key: 'config.carType', val: this.versionConfig.items[0].id });
    setTimeout(() => {
      if (this.$refs.policyView) this.$refs.policyView.$refs.mySwiper.swiper.autoplay.stop();
      if (this.$refs.car) {
        $(this.$refs.car.$el).css({ opacity: 0 });
      }
      if(this.exteriorConfig.selectId){
        this.$refs.outSideColorList.onSelect(this.exteriorConfigItems[this.exteriorConfig.selectId],this.exteriorConfig.selectId);
      }
    }, 1000);
    this.updateConfigUrl();

  },
};
export { main };
